/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Min_RequiredInputs */

const en_email_min_required = /** @type {(inputs: Email_Min_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At least 1 character required`)
};

const nl_email_min_required = /** @type {(inputs: Email_Min_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimaal 1 teken vereist`)
};

/**
* | output |
* | --- |
* | "At least 1 character required" |
*
* @param {Email_Min_RequiredInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_min_required = /** @type {((inputs?: Email_Min_RequiredInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Min_RequiredInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_email_min_required(inputs)
	return en_email_min_required(inputs)
});